import * as React from 'react';
import icon from '../../assets/img/flags/minnesota.svg';

export const Minnesota = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
